import { http } from './http';

export async function getExpiryDates(params) {
    try {
        return await http.get('wms/special/expiry/', { params });
    } catch (e) {
        if (e.status === 404) return { data: mockExpiryDates };
        throw e;
    }
}

export async function getDepreciation(params) {
    return http.get('wms/depreciations/', { params });
}

export async function createDepreciation(data) {
    return http.post('wms/depreciations/', data);
}

export async function updateDepreciation(id, data) {
    return http.patch(`wms/depreciations/${id}/`, data);
}

export async function deleteDepreciation(id) {
    return http.delete(`wms/depreciations/${id}/`);
}

export async function getTempStorage(params) {
    try {
        return await http.get('wms/special/temp-storage/', { params });
    } catch (e) {
        if (e.status === 404) return { data: mockTempStorage };
        throw e;
    }
}

export async function createTempStorage(data) {
    return http.post('wms/special/temp-storage/', data);
}

export async function updateTempStorage(id, data) {
    return http.patch(`wms/special/temp-storage/${id}/`, data);
}

export async function getWeaponIssues(params) {
    try {
        return await http.get('wms/special/weapon-issues/', { params });
    } catch (e) {
        if (e.status === 404) return { data: mockWeaponIssues };
        throw e;
    }
}

export async function createWeaponIssue(data) {
    return http.post('wms/special/weapon-issues/', data);
}

export async function updateWeaponIssue(id, data) {
    return http.patch(`wms/special/weapon-issues/${id}/`, data);
}
